import {useTranslation} from "react-i18next";
import {Paper} from "@material-ui/core";
import { createStyles, Theme } from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        anchorColor: {
            '& a': {
                color: theme.palette.type === 'dark' ? '#90caf9' : undefined
            }
        }
    }),
);

export function CustomerServicePage() {
    const {t} = useTranslation();
    const classes = useStyles();

    return (<Paper style={{flexGrow: "inherit", alignItems: "center", justifyContent: "center", display: "flex"}}>
        <div className={classes.anchorColor} dangerouslySetInnerHTML={{__html: t("menu.zapati")}}/>
    </Paper>)
}